
    import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
    import api from '@/api'
    import {imageUrl} from '@/utils/common'

    @Component({
        name: "uploadNew",
        components: {}
    })

    export default class extends Vue {
        // @Prop({ default: [{image_name: '', image_url: ''}] }) private fileList!: any;

        loading = false
        baseUrl = imageUrl
        dataAuth: any = {};
        fileList: any = []

        handleAvatarSuccess2(res: any, file: any) {
            this.fileList = []
            this.loading = false
            if(res.data && res.errcode == 0) {
                this.$message.success('上传成功')
                let obj = {
                    name: file.name,
                    filecode: res.data
                }
                this.fileList = [...this.fileList, obj]
                this.$emit('getData', this.fileList)
            } else {
                this.$message.warning('上传失败，请重新上传')
            }
        }

        beforeAvatarUpload2(file: any) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            let _that = this;
            this.loading = true
            return new Promise(function (resolve, reject) {
                api
                    .getPolicy({
                        file_name: file.name,
                    })
                    .then((data) => {
                        _that.dataAuth = data;
                        resolve(true);
                    })
                    .catch(() => {
                        reject(false);
                    }).finally(() => {

                });
            });
        }

    }
